import { Button } from '@svs/ui/react/button';
import { SheetClose } from '@svs/ui/react/sheet';
import type { ComponentProps, ReactNode } from 'react';

type TipsenSheetCloseProps = ComponentProps<typeof Button>;

/**
 * TipsenSheet footer wrapper.
 *
 * @param props Component props
 * @returns TipsenSheet footer wrapper.
 */
export default function TipsenSheetClose(props: TipsenSheetCloseProps): ReactNode {
  return (
    <SheetClose asChild>
      <Button {...props} />
    </SheetClose>
  );
}
